<template>
<div>
    <!-- EMPLOYEE TYPE -->
    <div class="full">
        <div class="header">
            <div class="label">Arbeits- und Ruhezeiten</div>
        </div>
    </div>
    <div class="full" v-if="employeetype != null">
        <div class="half left">
            <div class="full">
                <div class="half">
                    <div class="full">
                        <div class="label">Monatstunden</div>
                        <div class="label data">{{employeetype.monthTimeRegular / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">Wochenarbeitszeit</div>
                        <div class="label data">{{employeetype.weekTimeRegular / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">Reguläre Stunden pro Tag</div>
                        <div class="label data">{{employeetype.dayTimeRegular / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">Arbeitstage pro Woche</div>
                        <div class="label data">{{employeetype.weekWorkDaysRegular}}</div>
                    </div>
                </div>
                <div class="half">
                    <div class="full">
                        <div class="label">Monatsstunden überschreiten</div>
                        <div class="label data">{{employeetype.monthTimeMaxType? 'erlaubt' : 'nicht erlaubt' }}</div>
                    </div>
                    <div class="full">
                        <div class="label">Max. Stunden pro Woche</div>
                        <div class="label data">{{employeetype.weekTimeMax / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">Max. Stunden pro Tag</div>
                        <div class="label data">{{employeetype.dayTimeMax / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">Max. Arbeitstage pro Woche</div>
                        <div class="label data">{{employeetype.weekWorkDaysRegular}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="half right">
            <div class="full">
                <div class="full">
                    <div class="label">Pause zwischen Schichten</div>
                    <div class="label data">{{ employeetype.restTime /60 + ' Stunden' }}</div>
                </div>
                <div class="full">
                    <div class="label">Ruhezeit pro Woche</div>
                    <div class="label data">{{ employeetype.weekSpareTimeMin / 60 + ' Stunden' }}</div>
                </div>
                <div class="full">
                    <div class="label">Min. Anzahl freier Tage pro Woche</div>
                    <div class="label data">{{ employeetype.weekSpareDaysMin }}</div>
                </div>
                <div class="full">
                    <div class="label">Max. Anzahl aufeinanderfolgender Arbeitstage</div>
                    <div class="label data">{{ employeetype.daysConsecutiveMax > 0? employeetype.daysConsecutiveMax : 'unbegrenzt' }}</div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="full">
            <div class="label">
                Einstellungen noch nicht vorhanden, jetzt hinzufügen&nbsp;
            </div>
            <i class="fas fa-plus-circle toggleExpanded" role="button" @click="createEmployeetype()"></i>
        </div>
    </div>
    <!-- END EMPLOYEE TYPE -->

    <!-- EMPLOYEE RULES -->
    <div class="full">
        <div class="header">
            <div class="label">Bei der Planung berücksichtigen</div>
        </div>
    </div>
    <div class="full" v-if="employeerules != null">
        <div class="half left">
            <div class="full">
                <div v-for="rule in rulesLeft()" v-bind:key="rule.id" class="full">
                    <div class="label">{{ rule.description }}</div>
                    <i class="fas fa-check-circle checkbox" v-bind:class="{'true' : isRuleActive(rule.id), 'false' : !isRuleActive(rule.id)}" style="pointer: default; pointer-events: none;"></i>
                </div>
            </div>
        </div>

        <div class="half right">
            <div class="full">
                <div v-for="rule in rulesRight()" v-bind:key="rule.id" class="full">
                    <div class="label">{{ rule.description }}</div>
                    <i class="fas fa-check-circle checkbox" v-bind:class="{'true' : isRuleActive(rule.id), 'false' : !isRuleActive(rule.id)}" style="pointer: default; pointer-events: none;"></i>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="full">
            <div class="label">
                Einstellungen noch nicht vorhanden, jetzt hinzufügen&nbsp;
            </div>
            <i class="fas fa-plus-circle toggleExpanded" role="button" @click="createEmployeerules()"></i>
        </div>
    </div>
    <!-- END EMPLOYEE RULES -->
</div>
</template>

<script>
import grid from '../uicomponents/grid.vue'
import dropdown from '../uicomponents/dropdown.vue'
import searchbar from '../uicomponents/searchbar.vue'
import imagecrop from '../uicomponents/imagecrop.vue'
export default {
    components: {
        grid,
        dropdown,
        searchbar,
        imagecrop,
    },
    name: 'employeeplantype',
    data() {
        return {
            dataFiltered: [],
            loading: true,
            dragWatch: -1,
            mouseCurrent: {
                x: 0,
                y: 0
            },
            mouseDragStart: {
                x: 0,
                y: 0
            },
            scrolling: false,
            scrollTop: 150,
            collapseInput: false,
            collapseGrid: false,
            dropdowns: [],
            imagecrops: [],
            nameFilter: '',
            gridData: {
                header: [{
                        label: '',
                        description: 'Profile Picture',
                        map: (i) => i.profile_picture_storageServerId !== null && i.profile_picture_storageServerId !== '',
                        type: 'icon',
                        width: '50px',
                        enabled: true
                    },
                    {
                        label: 'Name',
                        map: (i) => i.firstName + ' ' + i.lastName,
                        type: 'text',
                        width: '220px',
                        enabled: true
                    }
                ],
                data: [],
            },
            availableRules: {
                desiredR: 'Wünsche berücksichtigen',
                undesiredR: 'Abneigungen berücksichtigen',
                weekendR: 'Freie Wochenenden',
                weekendDaysR: 'Verteilung Wochenendtage',
                skillR: 'Skills berücksichtigen',
                fairnessDefinitionR: 'Berücksichtigung von Fairness-Bedingungen',
                bioR: 'Biorhythmus berücksichtigen'
            }
        }
    },
    watch: {
        nameFilter: function (val, oldVal) {
            if (val === '') {
                this.dataFiltered = this.gridData.data.slice();
                return;
            }
            this.dataFiltered = this.gridData.data.filter(e => (e.firstName.toLowerCase() + ' ' + e.lastName.toLowerCase()).indexOf(val.toLowerCase()) > -1);
        }
    },
    props: [
        "employee",
        "employeetype",
        "employeerules"
    ],
    created() {},
    destroyed() {
        var settings = this;
        //window.clearTimeout(this.dragWatch);
        //document.body.removeEventListener('keydown', this.ScrollKey);
        /*var list = document.querySelectorAll('.employee-settings *');
        for(var x in list)
            if(!isNaN(parseInt(x))) list[x].removeEventListener('mousedown', this.StopScroll);*/
        //document.body.removeEventListener('mousemove', this.WatchMouse);
        if (document.querySelector('#imgupload')) document.querySelector('#imgupload').removeEventListener('change', settings.ProcessImageUpload);
        if (document.querySelector('#imguploadpublic')) document.querySelector('#imguploadpublic').removeEventListener('change', settings.ProcessImageUploadPublic);
        //document.body.removeEventListener('wheel', this.Scroll);
    },
    methods: {
        ToggleEdit($event, className) {
            var list = document.querySelectorAll('.code');
            for (var x in list)
                if (!isNaN(parseInt(x))) list[x].classList.remove('edit');
            $event.currentTarget.classList.toggle('edit');
            $event.currentTarget.childNodes[1].value = '';
            $event.currentTarget.childNodes[1].focus();
        },
        EndEdit($event) {
            var list = document.querySelectorAll('.code');
            for (var x in list)
                if (!isNaN(parseInt(x))) list[x].classList.remove('edit');
        },
        ToggleClassParent($event, className) {
            $event.currentTarget.parentNode.classList.toggle(className);
        },
        GetProfilePictureUrl(employee) {
            if (!employee.firstName || !employee.profile_picture_storageServerId) return '#e5e5e5';
            var d = new Date();
            return '#e5e5e5 no-repeat center/cover  url(https://fileserver1.meindienstplan.de/api/file?id=' + employee.profile_picture_storageServerId + '&accessToken=' + employee.profile_picture_storageServerToken + '&time=' + Date.now() + ')';
        },
        UpdateEmployee(employee, data) {
            var form = new FormData();
            var temp = {
                k: employee.id,
                v: data.value,
                c: data.field
            };
            for (var x in temp) form.append(x, temp[x]);
            this.$http.post('employees/update', form).then(function (response) {
                this.employee = response.data.data;
                this.$forceUpdate();
            });
            /*for(var i = 0; i < this.imagecrops.length;i++){
                this.imagecrops[i].callCancel();
            }*/
            this.imagecrops = [];
        },
        ChangeEmployee(employee) {
            for (var x in this.gridData.data) {
                this.gridData.data[x].selected = false;
            }

            this.employee = employee;
            this.employee.selected = true;
        },
        ToggleDropDown: function ($event, selection, offsetx, offsety) {
            var event = $event;
            var box = event.currentTarget.getBoundingClientRect();
            var dropdowns = this.dropdowns;
            this.dropdowns.push({
                items: selection,
                el: event.currentTarget,
                remainAfterSelect: true,
                toggled: true,
                offsetx: offsetx,
                offsety: offsety,
                posx: box.left + offsetx,
                posy: box.bottom + offsety,
                onceSelected: function ($eventInner, item, dropdown) {
                    var eventInner = $eventInner;
                    var boxInner = eventInner.currentTarget.getBoundingClientRect();
                    var temp = {
                        items: item.items,
                        //el: event.currentTarget,
                        offsetx: offsetx + 130,
                        offsety: offsety,
                        posx: box.left + offsetx + 130,
                        toggled: true,
                        posy: boxInner.bottom - 30,
                        pointerDirection: 3,
                        parentCallback: function () {
                            dropdown.toggled = false
                        }
                    };
                    dropdowns.push(temp);
                }
            });
        },
        country(code) {
            switch (code) {
                case 1:
                    return "Österreich";
                default:
                    return "unbekannt";
            }
        },
        isRuleActive(ruleID) {
            if (this.employeerules) {
                return ruleID in this.employeerules
            }
            return false;
        },
        rulesLeft() {
            var keys = Object.keys(this.availableRules);
            var count = keys.length;
            var rl = [];
            if (count > 0) {
                var div = Math.floor(count / 2);
                for (var i = 0; i < count - div; i++) {
                    var cur = {};
                    cur.id = keys[i];
                    cur.description = this.availableRules[keys[i]];
                    rl.push(cur)
                }
            }
            return rl;
        },
        rulesRight() {
            var keys = Object.keys(this.availableRules);
            var rl = [];
            var count = keys.length;
            if (count > 0) {
                var div = Math.floor(count / 2);
                for (var i = div + 1; i < count; i++) {
                    var cur = {};
                    cur.id = keys[i];
                    cur.description = this.availableRules[keys[i]];
                    rl.push(cur);
                }
            }
            return rl;
        },
        createEmployeerules() {
            console.log('create employeerules');
        },
        createEmployeetype() {
            console.log('create employeetype');
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
